import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME } from "src/constant/common";
import { useTranslation } from "react-i18next";
import { PATTERN_NON_ZERO_NUMBER, PATTERN_NUMBER } from "src/constant/common";

const EnvironmentPart = ({ errors, register }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <AccordionItem>
      <AccordionHeader targetId="3" className="mt-0 fw-bold">
        {t("new.environment.title")}
      </AccordionHeader>
      <AccordionBody accordionId="3">
        <div className="row">
          <div className="col-md-6">
            <FormInput
              register={register}
              label={t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`)}
              name={`environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`}
              placeholder={t("new.field_placeholder", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`) })}
              classInput="width-by-percent-80"
              errors={errors?.environment?.[FORM_NAME.ENVIRONMENT.WIND_SPEED]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`) })}
              unit="m/s"
            />
            <FormInput
              register={register}
              label={t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`)}
              name={`environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`}
              placeholder={t("new.field_placeholder", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`) })}
              classInput="width-by-percent-80"
              errors={errors?.environment?.[FORM_NAME.ENVIRONMENT.WIND_DIRECTION]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`) })}
              required
              pattern={{
                value: PATTERN_NUMBER,
                message: t("new.number_validate", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`) }),
              }}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`) })}
              unit="deg"
            />
            <FormInput
              register={register}
              label={t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`)}
              name={`environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`}
              placeholder={t("new.field_placeholder", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`) })}
              classInput="width-by-percent-80"
              errors={errors?.environment?.[FORM_NAME.ENVIRONMENT.AIR_DENSITY]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`) })}
              required
              valuePositive
              valuePositiveMessage={t("new.positive_number", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`) })}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`) })}
              unit="kg/m&sup3;"
            />
            <FormInput
              register={register}
              label={t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`)}
              name={`environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`}
              placeholder={t("new.field_placeholder", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`) })}
              classInput="width-by-percent-80"
              errors={errors?.environment?.[FORM_NAME.ENVIRONMENT.GRAVITY]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`) })}
              required
              pattern={{
                value: PATTERN_NON_ZERO_NUMBER,
                message: t("new.non_zero_number", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`) }),
              }}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`) })}
              unit="m/s&sup2;"
            />
            <FormInput
              register={register}
              label={t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`)}
              name={`environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`}
              placeholder={t("new.field_placeholder", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`) })}
              classInput="width-by-percent-80"
              errors={errors?.environment?.[FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`) })}
              required
              pattern={{
                value: PATTERN_NUMBER,
                message: t("new.number_validate", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`) }),
              }}
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`) })}
              unit="Pa"
            />
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default EnvironmentPart;
